<template>
  <v-data-table
    no-data-text="Không có dữ liệu"
    mobile-breakpoint="0"
    item-key="id"
    :headers="headers"
    :options.sync="tableOptions"
    :server-items-length="totalItems"
    :items="teachings"
    loading-text="Đang Tải"
    :footer-props="footerTable"
    :loading="loading"
  >
    <template v-slot:[`item.grade`]="{ item }">
      <router-link style="text-decoration: none" :to="'/grades/' + (item.grade && item.grade.id)">
        <span style="white-space: nowrap">{{ item.grade && item.grade.title }}</span>
      </router-link>
    </template>
    <template v-slot:[`item.class`]="{ item }">
      <router-link style="text-decoration: none" :to="'/class/' + (item.class && item.class.id)">
        <span style="white-space: nowrap" v-if="item.class">{{ item.class && item.class.title }}</span>
      </router-link>
    </template>
    <template v-slot:[`item.teacher.name`]="{ item }">
      <div v-for="teacher in item.teachers" class="d-flex flex-row" :key="teacher.id">
        <div class="mr-8">
          <CardTeacherName v-if="teacher" :teacher="teacher" link />
          <span v-else style="color: red">Chưa có giáo viên</span>
        </div>
      </div>
    </template>
    <template v-slot:[`item.assistant.name`]="{ item }">
      <div v-for="teacher in item.assistants" class="d-flex flex-row" :key="teacher.id">
        <div style="width: 220px" class="mr-8">
          <CardTeacherName v-if="teacher" :teacher="teacher" link />
          <span v-else style="color: red">Chưa có giáo viên</span>
        </div>
      </div>
    </template>
    <template v-slot:[`item.action`]="{ item }">
      <TeachingListAction :selectedTeaching="item" />
    </template>
  </v-data-table>
</template>
<script>
import { mapActions, mapState } from 'vuex'
import CardTeacherName from '@/components/basic/card/CardTeacherName.vue'
import TeachingListAction from '@/modules/teacher/TeachingListAction.vue'

const originHeaders = [
  {
    text: 'Học phần',
    value: 'grade',
    align: 'left',
    sortable: false,
    show: true,
  },
  {
    text: 'Lớp',
    value: 'class',
    align: 'left',
    sortable: false,
    show: true,
  },
  {
    text: 'Giáo viên',
    value: 'teacher.name',
    align: 'left',
    sortable: true,
    show: true,
  },
  {
    text: 'Trợ giảng',
    value: 'assistant.name',
    align: 'left',
    sortable: true,
    show: true,
  },
  {
    text: 'Thao tác',
    align: 'center',
    value: 'action',
    sortable: false,
    show: true,
  },
]

export default {
  components: {
    CardTeacherName,
    TeachingListAction,
  },
  data() {
    return {
      headers: originHeaders,
      tableOptions: {},
    }
  },
  computed: {
    ...mapState('teaching', ['teachings', 'totalItems', 'pageText', 'loading']),
    footerTable() {
      let footer = {
        'items-per-page-text': 'Số dòng mỗi trang',
        'items-per-page-all-text': 'Tất cả',
        'items-per-page': 10,
        'page-text': this.pageText,
      }
      if (this.totalItems > 100) {
        footer['items-per-page-options'] = [5, 10, 15]
      }
      return footer
    },
  },
  methods: {
    ...mapActions('teaching', ['searchTeaching', 'searchTeachings', 'requestPageSettings']),
    refresh(query) {
      this.searchTeachings({ ...query })
    },
  },
  created() {
    this.refresh({})
  },
  watch: {
    tableOptions: {
      handler(newOptions, oldOptions) {
        const itemPerPageChanged = newOptions.itemsPerPage !== oldOptions.itemsPerPage
        const pageChanged = newOptions.page !== oldOptions.page
        if (pageChanged || itemPerPageChanged) {
          this.requestPageSettings({
            page: newOptions.page,
            itemsPerPage: newOptions.itemsPerPage,
          })
        }
      },
      deep: true,
    },
  },
}
</script>
